module.exports = __webpack_public_path__ + "static/media/img3.2074dc8d.jpg";